// ----------------------------------------------------------------------
// <copyright file="Izenda.FormFontSettings.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * FormFontSettings component
 */
!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var FontFormat = require('share/components/controls/Izenda.FontFormat');
  var ColorStyling = require('share/components/controls/Izenda.ColorStyling');
  var ButtonGroup = require('share/components/controls/Izenda.ButtonGroup');

  var FORMAT_CONFIG = require('logic/data/Izenda.ReportPartFormConstants').FORMAT_CONFIG;

  var FormFontSettings = React.createClass({
    propTypes: {
      onChange: React.PropTypes.func
    },

    handleChange: function(item) {
      var props = this.props;
      if (item.value && !!this.props.editorControl) {
        props.editorControl.toggleFormat(item.value);
      }
    },

    handleChangeFont: function(data, item) {
      var editorControl = this.props.editorControl;

      switch (item.keyChange) {
        case 'fontFamily':
          var fontFamily = FORMAT_CONFIG.FONT_NAME[data.value.fontFamily];
          editorControl.execCommand('FontName', fontFamily);
          break;
        case 'fontSize':
          var fontSize = data.value.fontSize + 'px';
          editorControl.execCommand('FontSize', fontSize);
          break;
      }
    },

    handleChangeColor: function(data, item) {
      var editorControl = this.props.editorControl;

      switch (item.keyChange) {
        case 'textColor':
          editorControl.applyFormat('forecolor', data.value.textColor);
          break;
        case 'backgroundColor':
          editorControl.applyFormat('hilitecolor', data.value.backgroundColor);
          break;
      }
    },

    render: function() {
      var props = this.props;
      var fontFormat = this.props.value || {};
      var color = {
        textColor: fontFormat.textColor,
        backgroundColor: fontFormat.backgroundColor
      };

      return (
        <span className='u-posRelative izenda-FormSettings'>
          <FontFormat {...props} onChange={this.handleChangeFont} />
          <ButtonGroup
            {...props}
            className='u_inlineBlock'
            buttons={props.buttons.default}
            onChange={this.handleChange}
          />
          <br />

          <ButtonGroup
            {...props}
            className='u_inlineBlock'
            buttons={props.buttons.script}
            onChange={this.handleChange}
          />
          <ColorStyling value={color} className='u_inlineBlock' position='left' onChange={this.handleChangeColor} />
          <ButtonGroup
            {...props}
            className='u_inlineBlock'
            buttons={props.buttons.codeScript}
            onChange={this.handleChange}
          />
        </span>
      );
    }
  });

  module.exports = observer(FormFontSettings);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.FormFontSettings.jsx